module.exports = __webpack_public_path__ + "static/media/adserver_section4.e6ad7f6a.png";